// extracted by mini-css-extract-plugin
module.exports = {"display":"1","h1":"1","h2":"1","h3":"1","h4":"1","h5":"1","h6":"1"};